import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET_EARNING_OPTIONS } from "@/store/references/variables";
import { getEarningOptions } from "@/store/references/api";

export interface IEarningOption {
  earning_scheme_type: string;
  currency: string;
}

export interface IReferenceState {
  loading: boolean;
  earningSchemes: string[];
  earningOptions: IEarningOption[];
}

const initialState: IReferenceState = {
  loading: false,
  earningSchemes: [],
  earningOptions: [],
};

const getEarningOptions$ = createAsyncThunk(GET_EARNING_OPTIONS, async () => {
  const response = await getEarningOptions();
  return Promise.resolve(response.data as { earning_schemes: string[]; options: IEarningOption[] });
});

export const referenceSlice = createSlice({
  name: "reference",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEarningOptions$.fulfilled, (state, action) => {
      state.earningSchemes = action.payload.earning_schemes;
      state.earningOptions = action.payload.options;
    });
  },
});

export const referenceReducer = referenceSlice.reducer;

export { getEarningOptions$ };
